module.exports = __webpack_public_path__ + "media/packs/images/flags/GR-d46696a0efd1a480e33aefb7fce1308a.png";